"use strict";

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _lodash = require("lodash");

var _default = function _default(output) {
  if (Array.isArray(output)) {
    return output.join(' ');
  }

  if ((0, _lodash.isObject)(output)) {
    return Object.entries(output).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          val = _ref2[1];

      return "".concat(key, " ").concat(val);
    }).join('\n');
  }

  return output;
};

exports.default = _default;